<template>
<div id="global-nav">
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark" role="navigation">
                   

                        <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                            <span class="sr-only">Toggle navigation</span><span class="navbar-toggler-icon"></span>
                        </button> <a class="navbar-brand" id="pagelogo-a" href="#"> <img id="pagelogo" src="../assets/img/bonjour-logo.svg" /></a>
                    

                    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                        <ul class="nav navbar-nav">
                            <li class="active">
                                <a class="nav-link" href="/">Home</a>
                            </li>
                             <li>
                                <a class="nav-link" href="/flavors">Flavors</a>
                            </li>
                             <li>
                                <a class="nav-link" href="/content/packages">Packages</a>
                            </li>
                             <li>
                                <a class="nav-link" href="/content/events">Events</a>
                            </li>
                             <li>
                                <a class="nav-link" href="/content/customthemes">Custom Treats</a>
                            </li>
                             <li>
                                <a class="nav-link" href="/content/weddingspecialties">Wedding Desserts</a>
                            </li>
                            <li>
                                <a class="nav-link" href="https://www.hotplate.com/bonjourbrigadeiro" target="_blank">Order Now</a>
                            </li>
                           

                        </ul>
                      

                    </div>

                </nav>
    </div>
</template>
<script>
import Vue from 'vue';
import classie from 'classie'
export default  {
    name: 'Navigation',
    
};


</script>
<style lang="scss">
$navbar-light-color: #fff;
$navbar-dark-toggler-border-color: #eee;
$navbar-dark-color: #300B02;
@import './src/assets/scss/master.scss';

.navbar-dark .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}

#global-nav {
    .navbar {
        @media (min-width: 992px){
            height: 50px;
        }
    }
    
    .navbar-nav {
        a {
            font-family: "raleway",sans-serif;
        }
    
    }
    .navbar-collapse, .navbar-form {
      border: none;
  }

   .navbar-nav li>a:focus, .navbar-nav>.active>a,  .navbar-nav>.active>a:focus,  .navbar-nav>.active>a:hover {
      background-color: transparent;
      color: #F2A4C3;
  }

   .navbar-nav>li>a {
      color: #F8E1EA;
  }
   .navbar-nav>li>a:hover {
      color: #C52D6C;
  }
   .navbar {
    background-color: #300B02;
    border: none;
   }
     
  
  .navbar-brand {
      padding-top: 0px;
  }
  
    
}
   .home {
      @media (min-width:992px){
        #pagelogo {
                width: 200px;
                -webkit-transition: width 0.3s;
                -moz-transition: width 0.3s;
                -ms-transition: width 0.3s;
                -o-transition: width 0.3s;
                transition: width 0.3s;
            }
        #pagelogo-a
            {
                position: relative;
                top: 85px;
                width: 200px;
            }
        }
  }
  .content {
      #pagelogo-a {
        position: relative;
        width: 75px;
    }
    #pagelogo {
            width: 45px; 
        }
  }

    
    #pagelogo.smaller {
        width: 45px;
    }
    #pagelogo-a.smaller {
        width: 75px;
        top: 0px !important;
    }



</style>